<template>
    <page :title="pageTitle">
        <transition name="page" mode="out-in">
            <form @submit.prevent="register" v-if="!sent" :key="sent">
                <div class="row">
                    <div class="col-sm-8 offset-sm-2">
                        <h6 v-if="personal" class="page-title-small mt-5">{{ $t('account_personalInformation') }}</h6>
                        <div v-if="personal" class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="firstname">{{ $t('account_firstName') }}</label>
                                    <input v-model="formData.firstname"
                                           name="firstname"
                                           v-validate="'required'"
                                           :data-vv-as="$t('account_firstName')"
                                           id="firstname"
                                           type="text"
                                           class="form-control">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="middlename">{{ $t('account_middleName') }}</label>
                                    <input v-model="formData.middlename"
                                           name="middlename"
                                           :data-vv-as="$t('account_middleName')"
                                           id="middlename"
                                           type="text"
                                           class="form-control">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="lastname">{{ $t('account_lastName') }}</label>
                                    <input v-model="formData.lastname"
                                           name="lastname"
                                           v-validate="'required'"
                                           :data-vv-as="$t('account_lastName')"
                                           id="lastname"
                                           type="text"
                                           class="form-control">
                                </div>
                            </div>
                        </div>
                        <div v-if="personal" class="form-group">
                            <label for="licenseplate">{{ $t('account_licensePlate') }}</label>
                            <input v-model="formData.licenseplate"
                                   name="licenseplate"
                                   :data-vv-as="$t('account_licensePlate')"
                                   id="licenseplate"
                                   type="text"
                                   class="form-control">
                        </div>
                        <h6 class="page-title-small mt-5">{{ $t('account_accountInformation') }}</h6>
                        <div class="form-group" :class="{'has-danger': errors.has('email')}">
                            <label for="email">{{ $t('account_email') }}</label>
                            <input v-model="formData.email"
                                   name="email"
                                   v-validate="'required|email'"
                                   :data-vv-as="$t('account_email')"
                                   :class="{'form-control-danger': errors.has('email')}"
                                   id="email" type="email" class="form-control">
                            <small class="form-text text-danger" v-if="errors.has('email')">
                                {{ errors.first('email') }}
                            </small>
                        </div>
                        <div class="form-group" :class="{'has-danger': errors.has('password')}">
                            <label for="password">{{ $t('account_password') }}</label>
                            <input v-model="formData.password"
                                   name="password"
                                   v-validate="'required|min:3|confirmed:confirmpassword'"
                                   :data-vv-as="$t('account_password')"
                                   id="password" type="password" class="form-control"
                                   :class="{'form-control-danger': errors.has('password')}">
                            <small class="form-text text-danger" v-if="errors.has('password')">
                                {{ errors.first('password') }}
                            </small>
                        </div>
                        <div class="form-group" :class="{'has-danger': errors.has('confirmpassword')}">
                            <label for="password_confirm">{{ $t('account_passwordConf') }}</label>
                            <input v-model="formData.confirmpassword"
                                   v-validate="'required|min:3'"
                                   :data-vv-as="$t('account_passwordConf')"
                                   ref="confirmpassword"
                                   name="confirmpassword"
                                   id="password_confirm" type="password" class="form-control"
                                   :class="{'form-control-danger': errors.has('confirmpassword')}">
                            <small class="form-text text-danger" v-if="errors.has('confirmpassword')">
                                {{ errors.first('confirmpassword') }}
                            </small>
                        </div>
                        <div class="center">
                            <div class="form-group-btn">
                                <button type="submit" class="btn btn-primary pull-right" :disabled="errors.any()">{{ $t('account_createAccount') }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div class="row text-center" v-if="sent" :key="sent">
                <div class="col-md-8 offset-md-2">
                    <p>{{ $t('account_emailSent_p1') }}: {{ formData.email }}</p>
                    <p>{{ $t('account_emailSent_p2') }}</p>
                    <p>{{ $t('account_emailSent_p3') }}</p>
                </div>
            </div>
        </transition>
    </page>
</template>

<script>
import Page from './utilities/Page'
import { API } from '../api/axios'
import * as qs from 'qs'
import { mapGetters } from 'vuex'

export default {
  name: 'Register',
  components: {Page},
  props: {
    personal: {
      description: 'Personal info',
      required: false,
      default: false,
      type: Boolean,
    },
  },
  data () {
    return {
      formData: {
        email: '',
        password: '',
        confirmpassword: '',
        firstname: '',
        middlename: '',
        lastname: '',
        licenseplate: '',
      },
      sent: false,
    }
  },
  computed: {
    ...mapGetters(['language', 'reservation']),
    pageTitle () {
      return this.sent ? this.$t('account_userRegistered') : this.$t('account_registerUser')
    },
  },
  methods: {
    register () {
      let registerData = this.formData
      if (this.$route.params.transaction) {
        registerData.transactionid = this.$route.params.transaction
      }

      registerData.languageId = this.language

      this.$validator.validate().then(result => {
        if (!result) {
          console.log('Invalid!')
        } else {
          console.log('Valid')
          API.post(`/users/register?${qs.stringify(registerData)}`)
            .then(response => {
              console.log('Register response', response)
              this.sent = true
            })
            .catch(error => {
              if (error.response.data === 'Username already exists') {
                this.errors.add({
                  field: 'email',
                  msg: this.$t('account_userExists')
                })
              }
              console.error('Registration error', error.response.data)
            })
        }
      })
    },
  },
  mounted () {
    if (!this.personal) {
      delete this.formData.firstname
      delete this.formData.middlename
      delete this.formData.lastname
      delete this.formData.licenseplate
    }
  },
}
</script>

<style scoped>
    .page-enter-active, .page-leave-active {
        transition: opacity .3s;
    }

    .page-enter, .page-leave-to {
        opacity: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/Register.vue